var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-inline justify-center items-center",class:[_vm.size, _vm.background]},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.getSvg)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }